import './component/global';

const isEnvDevelopment = process.env.NODE_ENV === 'development';

__webpack_public_path__ = isEnvDevelopment
  ? 'http://127.0.0.1:9292/assets/'
  : `https:${window.cell.assetsPath}`;
